import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

import { inviteUser as inviteUserAPI } from "api/users";
import { usersKeys } from "api/users/queries";
import { NewUserPayloadType } from "api/users/types";
import AppDialog from "components/AppDialog";
import ModalHeader from "components/AppDialog/ModalHeader";
import { useUserStore } from "components/stores/UserStore";

import UserForm, { UserFormValues } from "./UserForm";

// LOGIC:

// TYPES:

interface NewUserModalProps {
  isOpen: boolean;
  handleClose: () => void;
}

const NewUserModal = ({ isOpen, handleClose }: NewUserModalProps) => {
  const [user] = useUserStore((s) => [s.user]);

  const queryClient = useQueryClient();

  const { mutateAsync: inviteUser, status } = useMutation(
    async (data: NewUserPayloadType) => {
      const res = await inviteUserAPI(data);
      await queryClient.invalidateQueries(usersKeys.list());
      return res.data;
    },
  );

  const handleSubmit = async (values: UserFormValues) => {
    await inviteUser(values, {
      onSuccess: () => handleClose(),
    });
  };

  return (
    <AppDialog open={isOpen} onClose={handleClose} maxWidth="md">
      <ModalHeader
        title="New User"
        subtitle="Invite a new user to your organisation."
      />
      <UserForm
        submitStatus={status}
        handleSubmit={handleSubmit}
        handleClose={handleClose}
        initialValues={{
          organisation: user?.organisation._id ?? "",
          email: "",
          role: null,
        }}
      />
    </AppDialog>
  );
};

export default NewUserModal;
